<template>
  <div
    class="c-app flex-row align-items-center"
    style="
         height: 100%;
        background-position: center;
        width: 100%;"
  >
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CHeaderBrand class="d-lg-none" to="/CoalInventory">
          <img
            src="img/arrow.png"
            width="60"
            style="padding-left:15px; padding-right:10px;"
          />
          <h3 style="padding-left: 12px;">
            <b>
              <font color="Green">{{ nameStock }}</font></b
            >
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <img
            src="img/arrow.png"
            width="60"
            @click="backClick()"
            style="padding-left:10px; padding-right:10px;"
          />
          <h2>
            <b>
              <font color="Green">{{ nameStock }}</font></b
            >
          </h2>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main amsys-ci-main">
          <CContainer fluid class="amsys-ci-cContainer">
            <transition name="fade" mode="out-in">
              <div>
                <CRow>
                  <CCol
                    sm="6"
                    class="amsys-ci-col"
                    v-for="item in result"
                    v-bind:data="item"
                    v-bind:key="item.Oid"
                  >
                    <transition name="fade">
                      <CCard border-color="secondary" style="width: 100%;">
                        <CCardBody>
                          <table border="0">
                            <tr>
                              <td style="text-align:center">
                                <h5><b>LOT</b></h5>
                                <h1>
                                  <b>{{ item.Lot }}</b>
                                </h1>
                                <h5>
                                  <b>{{ item.LotStatus }}</b>
                                </h5>
                              </td>
                              <td>
                                <h5>
                                  {{
                                    item.Qty.toFixed(2)
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  }}
                                  MT
                                </h5>
                                <font size="2"
                                  >Beg. Qty
                                  {{
                                    item.RemainingQty.toFixed(2)
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  }}
                                  MT</font
                                >
                                <br />
                                <font size="2"
                                  >Used. Qty
                                  {{
                                    item.UsedQty.toFixed(2)
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  }}
                                  MT</font
                                >
                                <hr
                                  style="margin-top:0rem; margin-bottom:0rem;"
                                />
                                <font size="2"><b>Analysis Result</b></font>
                                <table border="0">
                                  <tr>
                                    <td style="padding: 0px;">
                                      <font size="2">TM {{ item.TM }} %</font>
                                      <br />
                                      <font size="2">IM {{ item.IM }} %</font>
                                      <br />
                                      <font size="2">FC {{ item.FC }} %</font>
                                      <br />
                                      <font size="2">TS {{ item.TS }} %</font>
                                      <br />
                                      <font size="2">ASH {{ item.Ash }} %</font>
                                      <br />
                                    </td>
                                    <td style="padding: 0px;">
                                      <font size="2">HGI {{ item.HGI }} %</font>
                                      <br />
                                      <font size="2"
                                        >GAR
                                        {{
                                          item.GAR.toFixed(2)
                                            .toString()
                                            .replace(
                                              /(\d)(?=(\d{3})+(?!\d))/g,
                                              "$1,"
                                            )
                                        }}
                                        Kcal/Kg</font
                                      >
                                      <br />
                                      <font size="2"
                                        >ADB
                                        {{
                                          item.ADB.toFixed(2)
                                            .toString()
                                            .replace(
                                              /(\d)(?=(\d{3})+(?!\d))/g,
                                              "$1,"
                                            )
                                        }}
                                        Kcal/Kg</font
                                      >
                                      <br />
                                      <font size="2"
                                        >DAFB
                                        {{
                                          item.DAFB.toFixed(2)
                                            .toString()
                                            .replace(
                                              /(\d)(?=(\d{3})+(?!\d))/g,
                                              "$1,"
                                            )
                                        }}
                                        Kcal/Kg</font
                                      >
                                      <br />
                                      <br />
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </CCardBody>
                      </CCard>
                    </transition>
                  </CCol>
                </CRow>
              </div>
            </transition>
          </CContainer>
        </main>
      </div>
      <CRow class="justify-content-center">
        <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
      </CRow>
      <CRow class="justify-content-center">
        <div
          id="loading-contentx"
          v-if="loading"
          style="margin-bottom: 20%;"
        ></div>
      </CRow>
    </CWrapper>
  </div>
</template>
<script>
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "CoalInventoryDetail",
  components: {},
  data() {
    return {
      result: [],
      nameStock: "",
      showError: false,
      loading: false,
      notif: false,
    };
  },
  methods: {
    backClick() {
      this.$router.push({ path: "CoalInventory" });
    },
  },
  beforeMount() {
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlServer = url.toString(CryptoJS.enc.Utf8);
    this.loading = true;
    this.nameStock = this.$route.query.nameStock;
    console.log("CoalInventoryDetail");
    let data = localStorage.token;
    const form = new FormData();
    form.append("StockCode", this.nameStock);
    let sendData = JSON.stringify(Object.fromEntries(form));
    if (typeof data != "undefined") {
      axios
        .post(`${urlServer}/Api/CoalStock/GetCoalInventoryDetail/`, sendData, {
          headers: {
            "access-control-allow-origin": "*",
            "access-control-allow-methods": "delete, post, get, options",
            "access-control-allow-headers":
              "content-type, access-control-allow-headers, authorization, x-requested-with",
            "content-type": "application/json",
            authorization: "bearer " + data,
          },
        })
        .then((res) => {
          this.result = res.data;
          console.log(res.data);
          this.loading = false;
          //this.results = res.data[0];
        })
        .catch((error) => {
          console.error(error);
          vue.$toast.open({
            message: error,
            type: "error",
            position: "bottom",
            // all of other options may go here
          });
        });
    } else {
      this.$router.push({ path: "/pages/login" });
    }
  },
};
</script>
